import { Add, MoreVert } from "@mui/icons-material"
import { Fab, IconButton, List, ListItem, ListItemButton, ListItemText, ListSubheader, Menu, MenuItem } from "@mui/material"
import moment from "moment"
import { useState } from "react"
import { useThreadsContext } from "../../hooks/context"
import AiTeammateFetchingProgress from "../fetching-progress"
import "./style.scss"
import SaveableTextField from "components/saveable-text-field"
import { useAccountAlias } from "resources/account"

export default function AiTeammateThreadsList() {
  const accountAlias = useAccountAlias()
  const { threads, isFetching, openThread, newThread, setThreadIdToDelete, updateThread, isUpdatingThread } = useThreadsContext()
  const [anchorEl, setAnchorEl] = useState(null)
  const [threadIdToRename, setThreadIdToRename] = useState(null)

  function handleCloseMenu() {
    setAnchorEl(null)
  }

  function handleDelete() {
    const threadId = anchorEl?.dataset?.threadId
    if (!threadId) {
      return
    }
    setThreadIdToDelete(threadId)
    handleCloseMenu()
  }

  function handleRename() {
    const threadId = anchorEl?.dataset?.threadId
    if (!threadId) {
      return
    }
    setThreadIdToRename(threadId)
    handleCloseMenu()
  }

  async function renameThread(threadId, title) {
    await updateThread({ accountAlias, threadId, title })
    setThreadIdToRename(null)
  }

  function handleCancelRename() {
    setThreadIdToRename(null)
  }

  return <div className="ai-teammate-threads-list">
    <AiTeammateFetchingProgress isFetching={isFetching} />
    {threads && <List
      className="threads-list"
      subheader={<ListSubheader className="threads-list-subheader" disableSticky>
        Chat History
      </ListSubheader>}
    >
      {threads.map(({ threadId, title, updatedAt }) => {
        if (threadId === threadIdToRename) {
          return <ListItem key={threadId}>
            <SaveableTextField fullWidth className="thread-list-item-rename-text-field" size="small" value={title} onCancel={handleCancelRename} onSave={(title) => renameThread(threadId, title)} isSaving={isUpdatingThread} />
          </ListItem>
        }
        return <ListItemButton key={threadId} alignItems="flex-start" onClick={() => openThread(threadId, title)}>
          <ListItemText className="thread-list-item-text" primary={title} secondary={moment(updatedAt).fromNow()} />
          <IconButton
            data-thread-id={threadId}
            onClick={(e) => {
              e.stopPropagation()
              setAnchorEl(e.currentTarget)
            }}
            edge="end"
            aria-label="delete"
          >
            <MoreVert fontSize="small" />
          </IconButton>
        </ListItemButton>
      })}
    </List>}
    <Fab onClick={newThread} size="medium" className="new-chat-fab" variant="extended" color="primary" aria-label="New Chat">
      <Add />
      <span className="new-chat-fab-text">New Chat</span>
    </Fab>
    <Menu
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={handleCloseMenu}
    >
      <MenuItem onClick={handleRename}>Rename</MenuItem>
      <MenuItem onClick={handleDelete} className="danger">Delete</MenuItem>
    </Menu>
  </div>
}
